import React, { useEffect, useState } from 'react'
import { FormControl } from 'rsuite'
import { isValidators } from '../../../utils/ValidatorUtils'

export default function InputInlineForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onChange = () => {},
  inputWidth,
  isInputNumber = false,
  rows,
  componentClass,
  ...props
}) {
  const keyName = props?.name || schema?.name
  const disabled = props.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value || '')
  const placeholder = props.placeholder || schema?.hint || schema?.label

  // useEffect(() => {
  //   setInputValue(props.value || schema?.value || '')
  // }, [props.value, schema])

  useEffect(() => {
    var value = props.value || schema?.value || ''
    if (props.exValue) {
      value = props.value || ''
    }

    setInputValue(value)
    setValue(keyName, value)
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Controller
          key={keyName}
          name={keyName}
          control={control}
          rules={isValidators(schema.validators)}
          defaultValue={inputValue}
          render={(prop) => {
            return (
              <FormControl
                name="input"
                style={inputWidth && { width: inputWidth }}
                // readOnly={disabled}
                disabled={disabled}
                value={inputValue}
                placeholder={placeholder}
                errorMessage={errors[keyName]?.message}
                errorPlacement="topStart"
                rows={rows}
                componentClass={componentClass}
                onChange={(value) => {
                  if (isInputNumber && isNaN(value)) {
                  } else {
                    prop.onChange(value)
                    setInputValue(value)
                    onChange(value)
                  }
                }}
              />
            )
          }}
        />
      )}
    </>
  )
}
